module.exports = __webpack_public_path__ + "static/media/Phinisi Samudra Ilmu.8c196433.png";